

import {Component, Input, OnInit, ViewContainerRef} from '@angular/core';
import {ApiAdminUrgencyService} from "../../../../../services/api/admin/admin-urgency-api/admin-urgency-api.service";
import {DialogService} from "../../../../../services/dialog-service/dialog.service";
import {AdminUrgencyComponentDialog} from "./admin-urgency-create-edit-dialog/admin-urgency-create-edit-dialog.component";
import {ModalConfirmationComponent} from "../../../../../shared/modal-confirmation/modal-confirmation.component";

@Component({
  selector: 'app-admin-urgency',
  templateUrl: './admin-urgency.html'
})
export class AdminUrgencyComponent implements OnInit {

  @Input() requestTypeId;

  data;
  isLoading = true;

  constructor(private apiAdminUrgencyService: ApiAdminUrgencyService,
              private dialogService: DialogService,
              private viewReference: ViewContainerRef) {  }

  ngOnInit(): void {
    this.getData();
  }

  moveUp(id){
    this.apiAdminUrgencyService.moveUp(this.requestTypeId, id).then(response => {
      this.getData()
    })
  }
  moveDown(id){
    this.apiAdminUrgencyService.moveDown(this.requestTypeId, id).then(response => {
      this.getData()
    })
  }

  getData(){
    this.isLoading = true;
    this.apiAdminUrgencyService.listAll(this.requestTypeId).then(response => {
      this.data = response;
      this.isLoading = false;
    }).catch(error => {
      this.isLoading = false;
      if (error.status === 403) {
        window.location.href = '/';  // Redirect to self-service
      } else {
        console.log('Unhandled error:', error);
      }
    });
  }

  create(){
    // Replace null with Component
    this.dialogService.createDialog(AdminUrgencyComponentDialog, {id: null, requestTypeId: this.requestTypeId}, this.viewReference)
      .then(dialogSaved => {
        this.getData();
      }, dialogCancelled => {

      })
  }

  edit(id){
    // Replace null with Component
    this.dialogService.createDialog(AdminUrgencyComponentDialog, {id: id, requestTypeId: this.requestTypeId}, this.viewReference)
      .then(dialogSaved => {
        this.getData();
      }, dialogCancelled => {

      })
  }

  delete(id){
    this.dialogService.createDialog(ModalConfirmationComponent, 'Are you sure?', this.viewReference)
      .then(confirmed => {
        this.apiAdminUrgencyService.delete(this.requestTypeId, id).then(response => this.getData())
      }, cancelled => null)
  }



}
